import { TooltipWrapper } from '@va/ui/tooltips';
import { PropsWithChildren } from 'react';
import { Calendar } from './Calendar';
import { CalendarHeader } from './CalendarHeader';
import { useDateInputContext } from './DateInputContext';
import { Month } from './Month';
import { DateInputView } from './types';
import { Week } from './Week';
import { Year } from './Year';

type DateTooltipProps = {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
};

export const DateTooltip = ({ children, ...props }: PropsWithChildren<DateTooltipProps>) => {
  return (
    <TooltipWrapper useDefaultStyle={false} arrow={false} trigger='click' content={<DateTooltipContent />} {...props}>
      {children}
    </TooltipWrapper>
  );
};

const DateTooltipContent = () => {
  const {
    pickerViewState: { view },
  } = useDateInputContext();

  return (
    <div className='bg-white rounded-12 border border-black/10 p-1.5 min-w-[21.875rem]'>
      <CalendarHeader />
      {view === DateInputView.Month && <Month />}
      {view === DateInputView.Year && <Year />}
      {view === DateInputView.Day && (
        <>
          <Week />
          <Calendar />
        </>
      )}
    </div>
  );
};
